import { attr, fk } from 'redux-orm'
import Base from './Base'

class CommunicationRecipient extends Base {
  static get fields() {
    return {
      id: attr(),
      deleted: attr(),
      recipientType: attr(),
      recipientId: attr(),
      name: attr(),
      hasEmail: attr(),
      dossierId: fk({to: 'dossier', as: 'dossier', relatedName: 'communicationRecipients'}),
    }
  }
}

CommunicationRecipient.modelName = 'communicationRecipient';

export default CommunicationRecipient;
